module.exports = __webpack_public_path__ + "html/section-video-time_08f7f6f9b46e5272bce93c55d09fa60e.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-time.html
// module id = Jul4
// module chunks = 51